import { render, staticRenderFns } from "./AtualizarGrupoCaptura.vue?vue&type=template&id=216bc358&"
import script from "./AtualizarGrupoCaptura.vue?vue&type=script&lang=js&"
export * from "./AtualizarGrupoCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports